import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_FUMIGADO_SILOS } from '../../../config/forms'
import { OperacionesAltaFumigadoSiloDialogView } from '../components/OperacionesAltaFumigadoSiloDialogView'

class OperacionesAltaFumigadoSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesAltaFumigadoSiloDialogView
        silo={silo}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default reduxForm({
  form: FORM_FUMIGADO_SILOS,
  initialValues: { },
  enableReinitialize: true
})(connect(mapStateToProps)(OperacionesAltaFumigadoSiloDialog))
